import { css } from 'emotion'
import { PushTitle } from './..'

export const PushContentStyle = (background) => css({
  maxWidth: 450,
  '.push-content': {
    '&--desc': {
      // transform: 'translateY(-2rem)',
      '@media (max-width: 1024px)': {
        // transform: 'translateY(-1.5rem)',
        'a': {
          display: 'block',
          textAlign: 'center',
        }
      }
    },
    '&--picture': {
      position: 'relative',
      height: 250,
      overflow: 'hidden',
      maxWidth: '100%',
      '@media (min-width: 1024px)': {
        maxWidth: 'calc(11/12 * 100%)',
        marginLeft: 'calc(1/12 * 100%)',
        height: 320,
      },
      '.picture': {
        position: 'relative',
        height: '100%',
        background: `url(${background}) no-repeat center`,
        backgroundSize: 'cover',
        'img': {
          position: 'absolute',
          top: 0,
          left: '50%',
          height: '100%',
          maxHeight: 'none',
          maxWidth: 'none',
          transform: 'translateX(-50%)',
        },
      }
    }
  },
  'h3': {
    ...PushTitle,
    margin: 0,
    marginBottom: '1rem',
  }
})


// WEBPACK FOOTER //
// ./src/styles/components/pushContent.js